module.exports = __webpack_public_path__ + "static/garantie-2-511ce6a200768b7802fac5c531434006.svg";